<template>
    <svg :width="size" :height="size" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.5263 10.3341C13.1446 11.2368 12.5475 12.0322 11.7874 12.6509C11.0272 13.2695 10.1271 13.6925 9.16572 13.8829C8.20432 14.0734 7.21091 14.0254 6.27234 13.7432C5.33377 13.4609 4.47862 12.9531 3.78166 12.2641C3.08469 11.575 2.56713 10.7257 2.27422 9.79044C1.98132 8.85515 1.92198 7.86235 2.1014 6.89884C2.28082 5.93532 2.69354 5.03043 3.30347 4.26327C3.9134 3.49611 4.70198 2.89004 5.60025 2.49805" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 8.00002C14 7.21208 13.8448 6.43186 13.5433 5.70391C13.2418 4.97595 12.7998 4.31452 12.2427 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.1552 8.78793 2 8 2V8.00002H14Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
  
<script>
export default {
    props: {
        color: {
            required: false,
            type: String,
            default: '#A1A8B8'
        },
        size: {
            required: false,
            type: String,
            default: '16'
        }
    }
}
</script>
  